import { render, staticRenderFns } from "./jz.vue?vue&type=template&id=d7118a60&scoped=true"
import script from "./jz.vue?vue&type=script&lang=js"
export * from "./jz.vue?vue&type=script&lang=js"
import style0 from "./jz.vue?vue&type=style&index=0&id=d7118a60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7118a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7118a60')) {
      api.createRecord('d7118a60', component.options)
    } else {
      api.reload('d7118a60', component.options)
    }
    module.hot.accept("./jz.vue?vue&type=template&id=d7118a60&scoped=true", function () {
      api.rerender('d7118a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/jz.vue"
export default component.exports